import { render, staticRenderFns } from "./RelatedPages.vue?vue&type=template&id=4e38adf9&scoped=true&"
import script from "./RelatedPages.vue?vue&type=script&lang=js&"
export * from "./RelatedPages.vue?vue&type=script&lang=js&"
import style0 from "./RelatedPages.vue?vue&type=style&index=0&id=4e38adf9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e38adf9",
  null
  
)

export default component.exports